import * as THREE from 'three'
import Experience from '../experience.js'

export const PLATFORM_HEIGHT = 3.30468;
export const POLE_HEIGHT = 35; // 4.29768;

// Pole radius is 0.863 / 2.0;

export class PolePlatform {

    constructor() {
        this.experience = new Experience();
        this.gltfLoader = this.experience.gltfLoader;
        this.scene = this.experience.scene;
        this.setModel();
    }

    setModel() {
        this.gltfLoader.load('models/poleplatform.glb',
            (gltf) => {
                gltf.scene.rotation.y = - Math.PI; // Make the front face the camera
                this.scene.add(gltf.scene);
            }
        );
    }
}
